<sn-color-picker-control
  class="display-block"
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [tabindex]="templateOptions.tabindex || 0"
  (valueChange)="onValueChange($event)"
>
</sn-color-picker-control>
